import React from 'react';
import ProductPageTemplate from '../../components/ProductPageTemplate';

const DATA = {
  hero: {
    label: 'AI-Generated Questions',
    title: 'Real-world questions that test real skills',
    subtitle: 'Every question is generated by AI based on your actual job requirements — not generic templates. Test candidates on what they\'ll actually do on the job.',
    gradient: 'linear-gradient(150deg, #0076A3 0%, #0076A3 50%, #0076A3 100%)',
  },
  sections: [
    {
      label: 'Question Types',
      title: 'A complete library of question formats',
      features: [
        { icon: '✅', title: 'Multiple Choice', desc: 'Fast-scoring knowledge checks across frameworks, languages, and concepts. Auto-scored with explanation for incorrect answers.' },
        { icon: '✍️', title: 'Short Answer', desc: 'Open-ended questions that test understanding and communication. AI evaluates against expected topics and rubric criteria.' },
        { icon: '💻', title: 'Coding Challenges', desc: 'Write real code to solve practical problems. AI evaluates correctness, edge cases, time complexity, and code quality.' },
        { icon: '🎤', title: 'Interview Questions', desc: 'Open-ended verbal questions for video interviews. AI scores responses on depth, relevance, and communication.' },
        { icon: '🧩', title: 'System Design', desc: 'Architecture and design questions for senior roles. Evaluate trade-off thinking and scalability awareness.' },
        { icon: '📊', title: 'Data Analysis', desc: 'SQL queries, data interpretation, and analytical reasoning questions for data roles.' },
      ],
      columns: 3,
    },
    {
      label: 'AI Generation',
      title: 'Questions tailored to your exact requirements',
      desc: 'Upload a job description and AI generates questions that specifically test the skills you need. No generic question banks — every assessment is unique.',
      bullets: ['Generated from your actual JD', 'Covers all listed skills and requirements', 'Adjustable difficulty levels', 'Scoring rubrics auto-generated', 'Add, edit, or remove any question'],
      visual: '🧠',
      visualLabel: 'AI Question Generation Engine',
    },
  ],
  testimonial: { quote: 'The questions are so relevant to our actual work that candidates comment on how fair the process feels. That\'s a huge win for employer brand.', name: 'Lisa M.', role: 'CTO, CloudFirst' },
  cta: { title: 'Generate role-specific questions in seconds', desc: 'Upload a JD. Get a complete set of questions tailored to exactly what you need.' },
};

export default function AIQuestionsPage() { return <ProductPageTemplate data={DATA} />; }
